export default __webpack_public_path__ + "static/media/smile.fb3ceaa7.svg";